import { useEffect, useState } from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import { Contact, Href, Inbox, Home } from "../../Utils/Constants";
import { getLabel } from "../../sharedFunctions/CommonLable";
import { CustomTabItem, getCustomTabsForModule } from "../../sharedFunctions/customTabs";

import { isSystemConfigEnabled } from "../../sharedFunctions/SystemConfig";

type propsType = {
    basicTab: string;
    setBasicTab: (data: string) => void;
    employeeIdProp?: number;
    customTabs?: CustomTabItem[];
    showIcons?: boolean;
}

export default function BorderNav({ basicTab, setBasicTab, employeeIdProp, customTabs: customTabsProp, showIcons = false }: propsType) {
    const [customTabs, setCustomTabs] = useState<CustomTabItem[]>(customTabsProp || []);

    useEffect(() => {
        if (customTabsProp) {
            setCustomTabs(customTabsProp);
            return;
        }

        let isMounted = true;
        const loadTabs = async () => {
            const tabs = await getCustomTabsForModule('lms');
            if (isMounted) setCustomTabs(tabs);
        };
        loadTabs();

        const handleUpdate = () => {
            loadTabs();
        };
        window.addEventListener('customTabsUpdated', handleUpdate);
        window.addEventListener('labelsUpdated', handleUpdate);
        return () => {
            isMounted = false;
            window.removeEventListener('customTabsUpdated', handleUpdate);
            window.removeEventListener('labelsUpdated', handleUpdate);
        };
    }, [customTabsProp]);

    return (
        <Nav tabs className='border-tab nav-info mb-0 profile-nav-tabs'>
            <NavItem>
                <NavLink href="#" className={`nav-border txt-info tab-info ${basicTab === '1' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('1'); }}>
                    {showIcons && <i className="icofont icofont-ui-home" />}
                    {getLabel('User')}
                </NavLink>
            </NavItem>
            {employeeIdProp && <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '2' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('2'); }}>
                    {showIcons && <i className="icofont icofont-ui-message" />}
                    {getLabel('Attendance')}
                </NavLink>
            </NavItem>}
            {employeeIdProp && <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '3' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('3'); }}>
                    {showIcons && <i className="icofont icofont-man-in-glasses" />}
                    {getLabel('Reporting')}
                </NavLink>
            </NavItem>}
            {employeeIdProp && <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === 'lock_requests' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('lock_requests'); }}>
                    {showIcons && <i className="icofont icofont-unlock" />}
                    {getLabel('Lock Requests')}
                </NavLink>
            </NavItem>}
            {employeeIdProp && <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '4' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('4'); }}>
                    {showIcons && <i className="icofont icofont-ui-message" />}
                    {getLabel('Inputs')}
                </NavLink>
            </NavItem>}
            {employeeIdProp && <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '5' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('5'); }}>
                    {showIcons && <i className="icofont icofont-ui-message" />}
                    {getLabel('Leaves')}
                </NavLink>
            </NavItem>}
            {employeeIdProp && <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '6' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('6'); }}>
                    {showIcons && <i className="icofont icofont-bill-alt" />}
                    {getLabel('Expense')}
                </NavLink>
            </NavItem>}
            {employeeIdProp && <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '7' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('7'); }}>
                    {showIcons && <i className="icofont icofont-ui-calendar" />}
                    {getLabel('MTP')}
                </NavLink>
            </NavItem>}
            {employeeIdProp && isSystemConfigEnabled("holiday_approval_enable") && (
                <NavItem>
                    <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '8' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('8'); }}>
                        {showIcons && <i className="icofont icofont-sun-alt" />}
                        {getLabel('Holidays')}
                    </NavLink>
                </NavItem>
            )}
            {employeeIdProp && <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '9' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('9'); }}>
                    {showIcons && <i className="icofont icofont-bullhorn" />}
                    {getLabel('Brand Campaign')}
                </NavLink>
            </NavItem>}
            {employeeIdProp && isSystemConfigEnabled("targets_vs_achivements_enabled") && (
                <NavItem>
                    <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '10' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('10'); }}>
                        {showIcons && <i className="icofont icofont-chart-growth" />}
                        {getLabel('Target Vs Achievement')}
                    </NavLink>
                </NavItem>
            )}

            {/* Custom Tabs rendered after all static tabs */}
            {customTabs && customTabs.map((cTab) => (
                <NavItem key={cTab.id}>
                    <NavLink
                        href={Href}
                        className={`nav-border txt-info tab-info ${basicTab === cTab.id ? 'active' : ''}`}
                        onClick={(e) => {
                            e.preventDefault();
                            setBasicTab(cTab.id);
                        }}
                    >
                        {showIcons && <i className="icofont icofont-chart-pie" />}
                        {cTab.name}
                    </NavLink>
                </NavItem>
            ))}
        </Nav>
    )
}
